import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Heart = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="heart icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M23.9999 8.4977C24.0041 9.29751 23.8825 10.1028 23.6407 10.9093C23.4587 11.6624 22.6875 13.0682 22.3247 13.677C21.3406 15.2041 19.935 16.7111 18.1154 18.1593C15.2542 20.4366 12.4303 21.7662 12.3113 21.8219C12.2129 21.8677 12.1061 21.8907 11.9994 21.8907C11.8929 21.8907 11.7861 21.8677 11.6877 21.8219C11.5687 21.7662 8.74485 20.4366 5.88461 18.1593C2.01714 15.0812 -0.0175732 11.74 0.000114341 8.4977C0.0184451 5.11406 2.13677 2.6391 5.52796 2.0378C5.9679 1.9595 6.40205 1.92004 6.81819 1.92004C9.42534 1.92004 11.1028 3.48754 11.9994 4.93728C12.8963 3.48754 14.574 1.92004 17.1821 1.92004C17.598 1.92004 18.0318 1.9595 18.472 2.0378C21.8629 2.6391 23.9809 5.11406 23.9999 8.4977Z"
    />
  </svg>
)
